export default function initInfiniteScroll() {
  const loadMore = document.getElementById('load-more');
  if (loadMore) {
    window.isLoading = false;

    window.onscroll = () => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - (document.getElementById('footer')?.offsetHeight || 0) - 300) {
        if (window.isLoading) {
          return;
        }

        window.isLoading = true;

        if (document.getElementById('load-more')) {
          htmx.trigger('#load-more', 'click');
        }
      }
    };

    htmx.on('htmx:afterSwap', () => {
      window.isLoading = false;
      setTimeout(() => {
        const wrappers = document.querySelectorAll('.auction-catalogue:not(.loaded)');
        wrappers.forEach((wrapper) => {
          wrapper.classList.add('loaded');
        });
      }, 100);
    });
  }
}
